import React from 'react';

interface ActionLinkButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'danger';
  style?: React.CSSProperties;
}

export const ActionLinkButton: React.FC<ActionLinkButtonProps> = ({
  onClick,
  children,
  variant = 'primary',
  style,
}) => {
  const variantStyles = {
    primary: {
      backgroundColor: '#49D594',
      color: 'black',
      hover: {
        backgroundColor: '#3BC182',
      },
    },
    secondary: {
      backgroundColor: '#0E80D5',
      color: 'white',
      hover: {
        backgroundColor: '#0C6DB8',
      },
    },
    danger: {
      backgroundColor: '#F62F2F',
      color: 'white',
      hover: {
        backgroundColor: '#D92727',
      },
    },
  };

  const baseStyle = variantStyles[variant];

  return (
    <button
      onClick={onClick}
      style={{
        padding: '12px 24px',
        textDecoration: 'none',
        borderRadius: '8px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
        fontWeight: 300,
        fontFamily: 'Merriweather',
        fontSize: '16px',
        textAlign: 'center',
        border: 'none',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        backgroundColor: baseStyle.backgroundColor,
        color: baseStyle.color,
        ...style,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = baseStyle.hover.backgroundColor;
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = baseStyle.backgroundColor;
      }}
    >
      {children}
    </button>
  );
};
